import { twMerge } from 'tailwind-merge';

type ClassValue = string | number | null | undefined | false | ClassValue[];

function flatten(input: ClassValue): string {
  if (Array.isArray(input)) return input.map(flatten).filter(Boolean).join(' ');
  if (typeof input === 'string' || typeof input === 'number') return String(input);
  return '';
}

export function cn(...inputs: ClassValue[]): string {
  return twMerge(inputs.map(flatten).filter(Boolean).join(' '));
}
